import { getChallengesInOrder } from '@appt-digital/frontend-api-lib-wodity'

const getAllChallenges = async (search = '', type = 'user') => {
  const params = '{ "$or": [{"name": {"$contL": "' + search + '"}}]}'
  return await getChallengesInOrder(params, `&sort=start,DESC`)
}

export { getAllChallenges }
